import useStores from 'hooks/useStores';

import CardUpdated from 'pages/CardUpdated';
import CardEditor from 'pages/CardEditor';
import CardList from 'pages/CardList';
import Payment from 'pages/Payment';

import { PAGE_LIST } from 'constants/';
import { Observer } from 'mobx-react';

function Routes() {
  const { AppHandler } = useStores();

  return (
    <Observer>
      {() =>
        (AppHandler.page === PAGE_LIST.CARD_EDITOR && <CardEditor />) ||
        (AppHandler.page === PAGE_LIST.CARD_UPDATED && <CardUpdated />) ||
        (AppHandler.page === PAGE_LIST.CARD_LIST && <CardList />) ||
        (AppHandler.page === PAGE_LIST.CARD_PAYMENT && <Payment />)
      }
    </Observer>
  );
}

export default Routes;
